import store from "@/store";

export const adminRoutes = (to: any, from: any, next: any) => {
  // @ts-ignore
  if (store.state.user != null && store.state.user.user_tipo_id == 1) {
    next();
  } else {
    next("/");
  }
};

export const development = (to: any, from: any, next: any) => {
  // @ts-ignore
  if (process.env.VUE_APP_STATE == 2 || process.env.VUE_APP_STATE == 3) {
    next();
  } else {
    next("/");
  }
};

export const isLoggedInUser = (to: any, from: any, next: any) => {
  const isLoggedIn = !!store.state.user;

  if (!isLoggedIn && to.path.startsWith("/panel-facto")) {
    return next("/login");
  }

  if (isLoggedIn && ["/login", "/registro", "/registrar", "/recuperar"].includes(to.path)) {
    return next("/panel-facto/estadisticas");
  }

  return next();
};


